module.exports = __webpack_public_path__ + "static/media/downloadfile.e869e541.svg";